import {inject} from '@angular/core';
import {CanMatchFn, Route} from '@angular/router';
import {UiConfigService} from '@middleware';
import {first, map} from 'rxjs';

/**
 * Route guard to check if a module route is enabled based on the instance's UI configuration.
 */
export const moduleEnabledGuard: CanMatchFn = (route: Route) => {
  const uiConfigService = inject(UiConfigService);

  // The first segment of the route path, e.g., 'resource-explorer'
  const moduleSegment = route.path;

  // Derive the configuration slug (e.g., 'resource-explorer' -> 'resource_explorer')
  const slug = moduleSegment.replace(/-/g, '_');

  // Check the UI configuration service for the enabled status of the module
  return uiConfigService.getInstanceUIConfig().pipe(
    map(v => v.config_data),
    map(config => {
      const module = config[slug];

      return module?.enabled === true;
    }),
    first(),
  );
};
